// extracted by mini-css-extract-plugin
module.exports = {"productCarousel":"Fv-z","itemsContainer":"Gv-z"};